import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=f6d14eda&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=f6d14eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d14eda",
  null
  
)

export default component.exports